
document.addEventListener('DOMContentLoaded', function () {
    function feedInGram(weightdogkg, percentweightfunc, days) {
        return ((weightdogkg * 1000) / 100 * percentweightfunc) * days;
    }

    function getPercentOfIngredient(weightfeedfunc, percentingredientfunc, type, percentmeatfunc, days) {


        if (type.toLowerCase() === "fleisch" || type.toLowerCase() === "oil") {
            return (((weightfeedfunc / 100 * percentingredientfunc) / 100) * (type.toLowerCase() === "fleisch" ? percentmeatfunc : 100)) * days;
        } else {
            return (((weightfeedfunc / 100 * percentingredientfunc) / 100) * (100 - percentmeatfunc)) * days;
        }

    }

    let weightdogkg, feedpercentweight, percentmeat;

    function updateValues() {
        weightdogkg = document.getElementById('weightsliderfield').innerHTML;
        feedpercentweight = document.getElementById('weightpercentsliderfield').innerHTML;
        percentmeat = document.getElementById('percentmeatsliderfield').innerHTML;

    }

    // function setupSlider(sliderId, fieldId, min, max, step, initialValue) {
    //     const slider = document.getElementById(sliderId);
    //     const field = document.getElementById(fieldId);

    //     slider.min = min;
    //     slider.max = max;
    //     slider.step = step;
    //     slider.value = initialValue;

    //     slider.addEventListener('input', function () {
    //         field.innerHTML = slider.value;
    //     });

    //     slider.addEventListener('change', function () {
    //         updateValues();
    //         calculateDaily();
    //         calculateWeekly();
    //         calculateList();
    //     });
    // }


    // setListners to range inputs
    document.querySelectorAll(".barfrechner .slider__wrapper input").forEach(input => input.addEventListener("input",(event)=>{

        let target = event.target
        if(target){
            const resultSpan = target.closest(".slider__wrapper")?.querySelector("span[id]");
            if(resultSpan){
                resultSpan.innerHTML = input.value
            }
        }
        
        updateValues();
        calculateDaily();
        calculateWeekly();
        calculateList();
    }))


    function calculateDaily() {
        const weightfeed = feedInGram(weightdogkg, feedpercentweight, 1);
        document.getElementById('feedweightdaily').innerHTML = Math.round(weightfeed) + ' g';
        document.getElementById('animalweightdaily').innerHTML = Math.round(weightfeed / 100 * percentmeat) + ' g';
        document.getElementById('plantweightdaily').innerHTML = Math.round(weightfeed / 100 * (100 - percentmeat)) + ' g';



        document.querySelectorAll(".daily").forEach(function (element) {
            const percentingredient = element.getAttribute('rel');
            const type = element.getAttribute('rel2');

            const amountingredient = getPercentOfIngredient(weightfeed, percentingredient, type, percentmeat, 1);
            element.children[0].innerHTML = Math.round(amountingredient) + ' g';
        });
    }

    function calculateWeekly() {
        const weightfeedweekly = feedInGram(weightdogkg, feedpercentweight, 7);

        document.getElementById('feedweightweekly').innerHTML = Math.round(weightfeedweekly) + ' g';
        document.getElementById('animalweightweekly').innerHTML = Math.round(weightfeedweekly / 100 * percentmeat) + ' g';
        document.getElementById('plantweightweekly').innerHTML = Math.round(weightfeedweekly / 100 * (100 - percentmeat)) + ' g';

        document.querySelectorAll(".weekly").forEach(function (element) {
            const percentingredient = element.getAttribute('rel');
            const type = element.getAttribute('rel2');

            const amountingredient = getPercentOfIngredient(weightfeedweekly, percentingredient, type, percentmeat, 1);

            element.children[0].innerHTML = Math.round(amountingredient) + ' g';
        });
    }

    function calculateList() {
        const weightfeed = 1000 * document.getElementById('buyinglistkgsliderfield').innerHTML;

        document.getElementById('feedweightlist').innerHTML = (weightfeed / 1000) + ' kg';
        document.getElementById('animalweightlist').innerHTML = ((weightfeed / 100 * percentmeat) / 1000) + ' kg';
        document.getElementById('plantweightlist').innerHTML = ((weightfeed / 100 * (100 - percentmeat)) / 1000) + ' kg';

        document.querySelectorAll(".listly").forEach(function (element) {
            const percentingredient = element.getAttribute('rel');
            const type = element.getAttribute('rel2');

            const amountingredient = getPercentOfIngredient(weightfeed, percentingredient, type, percentmeat, 1);

            element.children[0].innerHTML = Math.round(amountingredient) + ' g';
        });
    }

    updateValues();
    calculateDaily();
    calculateWeekly();
    calculateList();
});
